export const parseBR = (raw) => {
  if (raw === null || raw === undefined || raw === '') return 0;

  let str = String(raw).trim();

  if (str.includes('.') && str.includes(',')) {
    const decimalSeparatorIndex = str.lastIndexOf(',');
    const thousandSeparatorIndex = str.lastIndexOf('.');

    if (decimalSeparatorIndex > thousandSeparatorIndex) {
      str = str.replace(/\./g, '').replace(',', '.');
    } else {
      str = str.replace(/,/g, '');
    }
  } else if (str.includes(',')) {
    str = str.replace(',', '.');
  }

  const n = Number.parseFloat(str);

  return Number.isFinite(n) && n !== -9999 ? n : 0;
};

const getDecimalPlaces = (n) => (Math.abs(n) < 1 ? 4 : 3);

export const formatBR = (raw, decimalPlaces = null) => {
  const num = parseBR(raw);

  if (!Number.isFinite(num)) {
    return '0,00';
  }

  const places = decimalPlaces !== null ? decimalPlaces : getDecimalPlaces(num);

  return num.toLocaleString('pt-BR', {
    minimumFractionDigits: places,
    maximumFractionDigits: places,
  });
};

export const trunc = (raw, decimals = 3) => {
  const num = parseBR(raw);
  const factor = 10 ** decimals;
  return Math.trunc(num * factor) / factor;
};

export const formatInteger = (raw) => {
  const num = parseBR(raw);
  return Number.isFinite(num) ? Math.trunc(num).toLocaleString('pt-BR') : '0';
};